import React, { useContext } from 'react';
import styled from 'styled-components/macro';
import { useNavigate } from 'react-router-dom';

import { fontDefaultAlt, IconArrowRight } from '@mirinae/react-ui';

import ProgressContext from '@mirinae/lessons/modules/contexts/progress';
import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import GlobalContext from '@mirinae/lessons/modules/contexts/global';
import { lessonsPaths, explorerPaths, membersPaths, authPaths} from '@mirinae/shared/defines/paths';
import { lessonsPalette } from '@mirinae/lessons/modules/defines/styles';

const IconButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: 0;
    border-radius: 20px;
    background-color: ${props => (props.theme === 'start' ? lessonsPalette.default[4] : props.theme === 'complete' ? lessonsPalette.default[2] : lessonsPalette.default[5])};
    &:hover:not(:disabled) {
        background-color: ${props => (props.theme === 'start' ? lessonsPalette.darken[4] : props.theme === 'complete' ? lessonsPalette.darken[2] : lessonsPalette.darken[5])};
    }
    &:disabled {
        background-color: ${lessonsPalette.grey[5]};
    }
`;

const CardButton = styled.div`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 100%;
    height: 48px;
    padding: 0 26px;
    border-radius: 25px;
    background-color: ${props => (props.theme === 'start' ? lessonsPalette.default[4] : props.theme === 'complete' ? lessonsPalette.default[2] : lessonsPalette.default[5])};
    color: ${lessonsPalette.primary.white};
    font-size: 17px;
    font-weight: 700;
    font-family: ${fontDefaultAlt};
    text-transform: capitalize;

    span {
        display: block;
        width: 100%;
        text-align: center;
        line-height: 100%;
        white-space: nowrap;
    }
    svg {
        width: 8px;
        height: 14px;
        margin-left: 10px;
    }
`;

const MiniLessonGoButton = ({ section, size }) => {
    const progress = useContext(ProgressContext);
    const navigate = useNavigate();
    const player = useContext(PlayerContext);
    const global = useContext(GlobalContext);

    if (!section)
        return null;

    const sectionStatus = progress.sections[section.nodeID];
    const starting = !sectionStatus || sectionStatus.progress === 0;
    const complete = !sectionStatus || sectionStatus.progress === 100;
    const sectionLink = () => {
        let link = `${lessonsPaths.player}/${global.currentLessonObject._id}/`;
        const lastEvent = sectionStatus && sectionStatus.lastEvent;
        const destPage = lastEvent && (lastEvent.action === 'complete' ? lastEvent.context.page : lastEvent.details.to.page);
        if (destPage && destPage !== player.currentPage.nodeID) // if passed through mini-lesson without completing exercise, start again
            link += destPage;
        else
            link += section.children[0].nodeID; // first page in section if starting out
        return link;
    };

    const goClicked = () => {
        const toContext = { step:0, page: section.children[0].nodeID, section: section.nodeID };
        player.postEvent({ action: 'enterMiniLesson', context: player.currentContext(), details: { to: toContext } });
        navigate(sectionLink());
    };

    return (size === 'large'
        ? (
            <CardButton data-t={`minilesson-btn-${section.nodeID}`} onClick={goClicked} theme={starting ? 'start' : 'continue'}>
                <span>{starting ? 'Start' : 'Continue'}</span>
                <IconArrowRight color={lessonsPalette.primary.white} />
            </CardButton>
        ) : (
            <IconButton onClick={goClicked} theme={starting ? 'start' : complete ? 'complete' : 'continue'}>
                {/* <ButtonIcon starting={starting} /> */}
                <IconArrowRight color={lessonsPalette.primary.white} />
            </IconButton>
        )
    );
};

export default MiniLessonGoButton;
